import BaseState from '@state/BaseState'
import GameStatesEnum from "../GameStatesEnum";
import { Signals} from "@/Imports";


export default class FreeSpinsBuyState extends BaseState {
    begin() {
        this.model.isFreespinsStarted = true
        this.model.isFreespinsMode = true

        Signals.buyFreespinsComplete.addOnce(this.onBuyFreespinsComplete, this)
        Signals.buyFreespins.dispatch()

        // Stop autospins
        document.dispatchEvent(new CustomEvent("setAutospinStop"))
        Signals.stopAutoplay.dispatch(true);
    }

    onBuyFreespinsComplete = () => {
        this.end()
    }

    end = () => {
        this.stateMachine.setState(GameStatesEnum.FINAL)
    }

    cleanUp() {
        Signals.buyFreespinsComplete.remove(this.end, this)
    }
}
